
import axios from 'axios';
import cookies from 'vue-cookies';
import router from '@/router/index';

import Templates from '@/lib/obTemplates';

import Helper from '@/lib/langTemplates/HelperClauses';

const baseUrl = 'https://3eunx8rcp7.execute-api.eu-west-1.amazonaws.com/dev/';

import Countries from '@/lib/countries';
const csc = require('country-state-city').default;
const countries = Object.keys(Countries).map(k => {
  return {
    code: k,
    name: Countries[k].name
  }
});

const Onboard = {

  state: {
    obEntity: '',
    fIndex: 0,
    obStep: 0,
    obSubStep: 0,
    obPacket: {},
    cities: [],
    newFloor: false
  },

  mutations: {

      setOnboardEntity(state, entity){
        state.obEntity = entity;
      },

      triggerObStep(state, step){
        state.obStep = step;
        state.obSubStep = 0;
      },
      triggerObSubStep(state, step){
        state.obSubStep = step;
      },

      addObSearchResult(state, result){
        state.obPacket[result.prop] = result.val;
      },

      clearPacket(state){
        const entity = state.obEntity;
        state.obStep = 0;
        state.obSubStep = 0;
        state.cities = [];
        if (entity !== 'room') {
          state.obPacket = {};
        }
        if (entity === 'room') {
          state.obPacket = {
            fIndex: state.obPacket.fIndex,
            floorName: state.obPacket.floorName
          }
        }
      },

      setCities(state, cities){
        state.cities = cities;
      },

      initNewRoom(state, floor){
        state.fIndex = floor.index;
        state.obPacket.floorName = floor.name ? floor.name : `Floor ${floor.index}`;
        if (!floor.rooms || !floor.rooms.length){ state.newFloor = true};
        state.obEntity = 'room';
        router.push({path: '/onboard'});
      },

      setApid(state, apid){
        state.obPacket.apid = apid.apid;
        state.obPacket.deviceId = apid.deviceId;
        state.obPacket.configuration = 'IN_UNIT';
        state.obPacket.size = 'S_10x24x1';
      },

      setBldgState(state, bldgState){
        state.obPacket.state = bldgState;
      },

      selectObUnits(state, units){
        state.obPacket.units = units;
      },

      clearOBProp(state, prop){
        state.obPacket[prop] = null;
      }

  },

  getters: {

    getSearchedCountry: state => input => {
      let filtered = countries.filter(c => {
        if (
          c.code.toLowerCase().includes(input.toLowerCase()) ||
          c.name.toLowerCase().includes(input.toLowerCase())
        ) return c;
      });
      let us = filtered.find(c => c.code.toLowerCase() === 'us');
      let jp = filtered.find(c => c.code.toLowerCase() === 'jp');
      let uIndex = filtered.indexOf(us);
      let jIndex = filtered.indexOf(jp);
      if (jp) {
        filtered.splice(jIndex, 1);
        filtered.unshift(jp);
      }
      if (us) {
        filtered.splice(uIndex, 1);
        filtered.unshift(us);
      }
      return filtered;
    },

    obProps: state => () => {
      return Object.keys(state.obPacket).map(o => {
        let step = Templates[state.obEntity].steps.find(s => s.subSteps.find(b => b.inputs.find(i => i.val === o)));
        if (step !== undefined) {
          let subStep = step.subSteps.find(b => b.inputs.find(i => i.val === o));
          let input = subStep.inputs.find(i => i.val === o);
          return {prop: o, val: state.obPacket[o], label: input.label === 'fType' ? 'filter' : input.label, step: Templates[state.obEntity].steps.indexOf(step), subStep: step.subSteps.indexOf(subStep)};
        } else {
          return null;
        }
      }).filter(x => x !== null);
    },

    getSearchedCity: state => input => {
      return state.cities.filter(c => {
        let byCity = c.city.toLowerCase();
        let byState = c.state.toLowerCase();
        let bySpace = `${byCity} ${byState}`;
        let byComma = `${byCity}, ${byState}`;
        if ([byCity, byState, bySpace, byComma].some(i => i.includes(input.toLowerCase())) || !input || !input.length) return c;
      })
    }

  },

  actions: {

      setObStep(context, step){
        context.commit('triggerObStep', step);
      },
      setObSubStep(context, step){
        context.commit('triggerObSubStep', step);
      },

      initOnboard(context, entity){
        context.commit('setOnboardEntity', entity);
        router.push({path: '/onboard'});
      },

      setObSearchResult(context, result){
        context.commit('addObSearchResult', result);
      },

      clearObPacket(context){
        context.commit('clearPacket');
      },

      async submitObRequest(context, breakpoint){
        const errs = {
          access: {
            type: 'err',
            title: Helper.clauses.accFail[`${context.rootState.lang}Title`],
            body: Helper.clauses.accFail[context.rootState.lang]
          },
          bldg: {
            type: 'err',
            title: Helper.clauses.bldgAddFail[`${context.rootState.lang}Title`],
            body: Helper.clauses.bldgAddFail[context.rootState.lang]
          },
          room: {
            type: 'err',
            title: Helper.clauses.roomAddFail[`${context.rootState.lang}Title`],
            body: Helper.clauses.roomAddFail[context.rootState.lang]
          },
          user: {
            type: 'err',
            title: Helper.clauses.userAddFail[`${context.rootState.lang}Title`],
            body: Helper.clauses.userAddFail[context.rootState.lang]
          }
        };
        const succs = {
          access: {
            type: 'notif',
            title: Helper.clauses.reqSent[`${context.rootState.lang}Title`],
            body: Helper.clauses.reqSent[context.rootState.lang]
          },
          bldg: {
            type: 'notif',
            title: Helper.clauses.bldgAdd[`${context.rootState.lang}Title`],
            body: Helper.clauses.bldgAdd[context.rootState.lang]
          },
          room: {
            type: 'notif',
            title: Helper.clauses.roomAdd[`${context.rootState.lang}Title`],
            body:  Helper.clauses.roomAdd[context.rootState.lang]
          },
          user: {
            type: 'notif',
            title: Helper.clauses.userAdd[`${context.rootState.lang}Title`],
            body: Helper.clauses.userAdd[context.rootState.lang],
          }
        };
        context.dispatch('loadingOn');
        try {
          let dispatch = `ob${context.state.obEntity}`;
          await context.dispatch(dispatch);
          context.dispatch('initNotif', succs[context.state.obEntity]);
          if (context.state.obEntity === 'access') {
            router.push({path: '/'});
          }
        } catch(err) {
          console.log({OB_ERROR: err});
          context.dispatch('initNotif', errs[context.state.obEntity]);
        }
        context.dispatch('loadingOff');
      },

      async obaccess(context){
        try {
          let axiosReq = {
            user: aggReduce(context.state.obPacket, 'email', 'firstName', 'lastName', 'org', 'phoneNumber'),
            org: aggReduce(context.state.obPacket, 'street', 'city', 'state', 'zipCode', 'country')
          };
          axiosReq.org.name = context.state.obPacket.org;
          axiosReq.user.lang = context.rootState.lang ? context.rootState.lang : 'en';
          const body = JSON.stringify(axiosReq);
          const org = (await axios.post(baseUrl + 'requestAccess', body)).data;
          context.dispatch('initNotif', {
            type: 'notif',
            title: Helper.clauses.reqSent[`${context.rootState.lang}Title`],
            body: Helper.clauses.reqSent[context.rootState.lang]
          });
        } catch(err) {
          console.log(err);
          context.dispatch('initNotif', {
            type: 'err',
            title: Helper.clauses.accFail[`${context.rootState.lang}Title`],
            body: Helper.clauses.accFail[context.rootState.lang]
          });
        }
      },

      async obbldg(context){
        const headers = {
          'Content-Type': 'application/json',
          Authorization: cookies.get('breeziProTkn')
        }
        try {
          let packet = context.state.obPacket;
          packet.streetExtended = (packet.streetExtended && packet.streetExtended.length) ? packet.streetExtended : ' ';
          const posted = (await(axios.post(baseUrl + 'buildings', JSON.stringify(context.state.obPacket), {
            headers: headers
          }))).data;
          const bId = posted.split(' ')[1];
          const url = `${baseUrl}bundle/${bId}`
          const bldg = (await axios.get(url, {headers: headers})).data;
          let buildings = context.rootState.buildings;
          buildings.push(bldg);
          context.commit('addNewBuilding', buildings);
        } catch(err) {
          throw err;
        }
      },

      async obroom(context){
        const headers = {
          'Content-Type': 'application/json',
          Authorization: cookies.get('breeziProTkn')
        }
        let newRoom = context.state.obPacket;
        newRoom.floorIndex = context.state.fIndex;
        newRoom.device = newRoom.deviceId;
        newRoom.altSize = `${newRoom.length}x${newRoom.width}x${newRoom.depth}${newRoom.units}`;
        newRoom.breakpoint = breakpoint;
        newRoom.buildingId = context.rootState.buildingId;
        // ['deviceId', 'length', 'width', 'depth', 'fIndex'].forEach(i => delete newRoom[i]);
        let url = `${baseUrl}rooms`;
        const breakpoint = newRoom.breakpoint;
        delete newRoom.breakpoint;
        try {
          let room = (await axios.post(url, JSON.stringify(newRoom), {headers: headers})).data;
          room = formatRoom(room);
          room.breakpoint = breakpoint;
          room.floorIndex = newRoom.floorIndex;
          room.floorName = newRoom.floorName ? newRoom.floorName : `Floor ${room.floorIndex}`;
          context.commit('addNewRoom', room);
        } catch(err) {
          throw err;
        }
      },

      async obuser(context){
        const url = baseUrl + 'team';
        const headers = {
          'Content-Type': 'application/json',
          Authorization: cookies.get('breeziProTkn')
        };
        try {
          await axios.post(url, JSON.stringify(context.state.obPacket), {headers: headers});
          router.push({path: '/organization'});
          context.commit('addUserToTeam', context.state.obPacket);
        } catch(err) {
          throw err;
        }
      },

      setCountryCities(context, code){
        const country = csc.getCountryByCode(code);
        const cities = csc.getStatesOfCountry(country.id)
          .reduce((a, i) => {
            let stateCities = csc.getCitiesOfState(i.id);
            stateCities.forEach(ct => {
              a.push({
                state: i.name,
                city: ct.name
              })
            });
            return a;
          }, []);
          context.commit('setCities', cities);
      },

      async validateLocation(context, location){
        try {
          await axios.post(baseUrl + 'validateLocation', JSON.stringify(location), {headers: {
            'Content-Type': 'application/json',
            Authorization: cookies.get('breeziProTkn')
          }})
          // await axios(params);
          return Promise.resolve();
        } catch(err) {
          return Promise.reject();
        }
      },

      async validateAPID(context, serialNum){
        const url = `${baseUrl}apid/AP${serialNum}`;
        const headers = {
          headers: {
            'Content-Type': 'application/json',
            Authorization: cookies.get('breeziProTkn')
          }
        }
        try {
          const apid = (await axios.get(url, headers)).data;
          if (apid.active) {
            context.commit('setApid', apid)
          } else {
            throw null;
          }
        } catch(err) {
          console.log({APID_VALIDATION_ERROR: err});
          throw err;
        }
      },

      setBuildingState(context, state){
        context.commit('setBldgState', state);
      },

      setObUnits(context, units){
        context.commit('selectObUnits', units);
      },

      removeOBProp(context, input){
        context.commit('clearOBProp', input);
      }

  }

};

function aggReduce(packet, ...atts){
  return atts.reduce((a, i) => {
    a[i] = (packet[i] && packet[i].length) ? packet[i] : ' ';
    return a;
  }, {});
}

class EmptyAlerts {
  constructor(){
    const self = this;
    const rdgs = ['days', 'ttp', 'hhm', 'iaq', 'co2'];
    rdgs.forEach(i => self[i] = {bad: 0, crit: 0});
  }
}

function formatRoom(room){
  return {
    alerts: new EmptyAlerts(),
    overallAlerts: {bad: 0, crit: 0},
    id: room.id,
    did: room.device,
    meas: ['days', 'ttp', 'hhm', 'iaq', 'co2'].reduce((a, i) => {
      a[i] = '-';
      return a;
    }, {}),
    info: ['altConfig', 'altSize', 'apid', 'device', 'fBrand', 'fModel', 'floorIndex', 'floorName', 'fBrand', 'fModel', 'fType', 'hardwareVersion', 'hvacName', 'manufacturer', 'modelNumber']
      .reduce((a, i) => {
        if (room[i]) {
          a[i] = room[i]
        }
        return a;
      }, {})
  }
}

export default Onboard;



// WEBPACK FOOTER //
// ./src/store/onboard.js